import { useState, useEffect, useCallback } from "react";
import {
  Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, FormControl, InputLabel, Select, MenuItem,
} from "@mui/material";
import apiService from "../../service/apiService";
import { format, parseISO } from "date-fns";
import { useNavigate } from 'react-router-dom';
import UploadIcon from '@mui/icons-material/Upload';
import * as XLSX from "xlsx";
import { Pagination } from "react-bootstrap";
import { FaEye, FaRegEdit, FaTrash } from "react-icons/fa";
import { Modal } from "react-bootstrap";
import { Download } from "@mui/icons-material";
import { FormHelperText } from '@mui/material';
import { debounce } from "lodash";

const Cropcosting = () => {
  const navigate = useNavigate();
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const [dist, setDist] = useState(loginData?.districtId ? loginData.districtId : 0);
  const [blk, setBlk] = useState(loginData?.blockId ? loginData.blockId : 0);

  // Essential state variables only
  const [rows, setRows] = useState([]);
  const [totalItems, setTotalitems] = useState(0);
  const [totalpage, setTotalpage] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [years, setYears] = useState([]);
  const [year, setYear] = useState(new Date().getFullYear());
  const [seasons, setSeasons] = useState([]);
  const [seeds, setSeeds] = useState([]);
  const [seedVarieties, setSeedVarieties] = useState([]);
  const [cropTypes, setCropTypes] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedCropCuttingId, setSelectedCropCuttingId] = useState(null);
  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [rowCount, setRowCount] = useState(0);

  // Filter states
  const [farName, setFarName] = useState("");
  const [season, setSeason] = useState("");
  const [district, setDistrict] = useState("");
  const [block, setBlock] = useState("");
  const [gramPanchayat, setGramPanchayat] = useState("");
  const [village, setVillage] = useState("");
  const [pgName, setPgName] = useState("");
  const [dateOfCropCutting, setDateOfCropCutting] = useState("");
  const [seedName, setSeedName] = useState('');
  const [seedVariety, setSeedVariety] = useState("");
  const [cropType, setCropType] = useState("");
  const [yield5x5, setYield5x5] = useState("");
  const [yieldPerHectare, setYieldPerHectare] = useState("");
  const [remarks, setRemarks] = useState("");

  const [formData, setFormData] = useState({
    SeasonId: "",
    cropCuttingDate: "",
    SeedId: "",
    SeedVarietyId: "",
    cropTypeId: "",
    yield5x5: "",
    yieldPerHectare: "",
    remarks: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const fetchData = async () => {
    try {
      const payload = {
        seedVarietyId: 0,
        cropTypeId: 0,
        farmerName: farName || "",
        seasonName: season || "",
        seedName: seedName || "",
        cropType: cropType || "",
        remarks: remarks || "",
        varietyName: seedVariety || "",
        pgName: pgName || "",
        pgCode: "",
        villageName: village || "",
        gpName: gramPanchayat || "",
        blockName: block || "",
        districtName: district || "",
        yield5x5: yield5x5 || "",
        yieldPerHectare: yieldPerHectare || "",
        year: year,
        dateOfCropCutting: dateOfCropCutting || "",
        mip: "",
        pageNumber: page,
        pageSize: 10,
      };

      const response = await apiService.post("/crop-cutting/get-crop-cutting-index", payload);

      if (response.data.status) {
        const formattedData = response.data.body.data.map((item) => ({
          id: item.cropCuttingId,
          farmerName: item.farmerName,
          seasonName: item.seasonName,
          districtName: item.districtName,
          blockName: item.blockName,
          gpName: item.gpName,
          villageName: item.villageName,
          pgName: item.pgName,
          cropCuttingDate: item.cropCuttingDate,
          seedName: item.seedName,
          seedVarietyName: item.seedVarietyName,
          cropType: item.cropType,
          yield5x5: item.yield5x5,
          yieldPerHectare: item.yieldPerHectare,
          remarks: item.remarks,
        }));
        setTotalitems(response.data.body.recordsCount);
        setTotalpage(response.data.body.pageCount);
        setRows(formattedData);
        setRowCount(response.data.body.recordsCount);
      } else {
        setTotalitems(0);
        setTotalpage(0);
        setRows([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setRows([]);
      setTotalitems(0);
      setTotalpage(0);
    }
  };

  const debouncedFetchData = useCallback(debounce(fetchData, 500), [
    page, farName, season, district, block, gramPanchayat, village, pgName,
    dateOfCropCutting, seedName, seedVariety, cropType, yield5x5, yieldPerHectare, remarks, year
  ]);

  useEffect(() => {
    debouncedFetchData();
    return () => debouncedFetchData.cancel();
  }, [debouncedFetchData]);

  const fetchAllDist = async () => {
    try {
      const response = await apiService.get('/districts/get-all');
      const currentDist = loginData?.districtId ? loginData.districtId : 0;
      if (currentDist) {
        const defDist = response.data.find((dis) => dis.districtId === currentDist);
        setDistrict(defDist ? defDist.districtName : "");
      }
    } catch (error) {
      setDistrict("");
      console.error('Error fetching districts:', error);
    }
  };

  const fetchBlocks = async () => {
    try {
      const response = await apiService.get(`/master/get-block-by-district/${dist}`);
      const currentBlock = loginData?.blockId ? loginData.blockId : 0;
      if (currentBlock) {
        const defBlock = response.data.body.blocks.find((blk) => blk.blockId === currentBlock);
        setBlock(defBlock ? defBlock.blockName : "");
      }
    } catch (error) {
      setBlock("");
      console.error("Error fetching blocks:", error);
    }
  };

  useEffect(() => {
    if (dist > 0) {
      fetchBlocks();
    }
  }, [dist]);

  useEffect(() => {
    fetchAllDist();
    
    // Fetch all dropdown data
    apiService.get("/seasons/get-all").then(response => setSeasons(response.data));
    apiService.get("/seeds/get-all").then(response => setSeeds(response.data));
    apiService.get("/seed-varieties/get-all").then(response => setSeedVarieties(response.data));
    apiService.get("/croptypes/get-all-croptypes").then(response => setCropTypes(response.data));
    
    apiService.get("/years/get-all").then(response => {
      setYears(response.data);
      const currentYear = new Date().getFullYear();
      const defaultYear = response.data.find((yr) => yr.yearValue === currentYear);
      setYear(defaultYear ? defaultYear.yearValue : response.data[0]?.yearValue);
    });
  }, []);

  const handleView = async (cropCuttingId) => {
    try {
      const response = await apiService.get(`/crop-cutting/crop-cutting/${cropCuttingId}`);
      if (response.data.length > 0) {
        setSelectedData(response.data[0]);
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleEdit = async (cropCuttingId) => {
    setSelectedCropCuttingId(cropCuttingId);
    try {
      const response = await apiService.get(`/crop-cutting/getId/${cropCuttingId}`);
      if (response.status === 200) {
        const fetchedData = response.data;
        setFormData({
          SeasonId: fetchedData.SeasonId || "",
          cropCuttingDate: fetchedData.CropCuttingDate || "",
          SeedId: fetchedData.SeedId || "",
          SeedVarietyId: fetchedData.SeedVarietyId || "",
          cropTypeId: fetchedData.CropTypeId || "",
          yield5x5: fetchedData.Yield5x5 || "",
          yieldPerHectare: fetchedData.YieldPerHectare || "",
          remarks: fetchedData.Remarks || "",
        });
        setOpen(true);
      }
    } catch (error) {
      console.error("Error fetching cutting details:", error);
    }
  };

  const handleDeleteClick = async (cropCuttingId) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this Cutting details?");
    if (!isConfirmed) return;

    try {
      const response = await apiService.delete(`/crop-cutting/delete/${cropCuttingId}`);
      if (response.status === 200 && response.data.status) {
        alert("Cutting data deleted successfully.");
        fetchData();
      }
    } catch (error) {
      console.error("Error deleting data:", error);
      alert("Failed to delete data. Please try again.");
    }
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.SeasonId) newErrors.SeasonId = "Season is required";
    if (!formData.cropCuttingDate) newErrors.cropCuttingDate = "Crop Cutting Date is required";
    if (!formData.SeedId) newErrors.SeedId = "Seed is required";
    if (!formData.SeedVarietyId) newErrors.SeedVarietyId = "Seed Variety is required";
    if (!formData.cropTypeId) newErrors.cropTypeId = "Crop Type is required";
    if (!formData.yield5x5) newErrors.yield5x5 = "Yield 5x5 is required";
    if (!formData.yieldPerHectare) newErrors.yieldPerHectare = "Yield Per Hectare is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!selectedCropCuttingId || !validateForm()) return;

    const updatedPayload = {
      farmerId: selectedCropCuttingId,
      seasonId: formData.SeasonId,
      seedId: formData.SeedId,
      seedVarietyId: formData.SeedVarietyId,
      cropCuttingDate: formData.cropCuttingDate,
      cropTypeId: formData.cropTypeId,
      yield5x5: formData.yield5x5 ? parseFloat(formData.yield5x5) : 0,
      yieldPerHectare: formData.yieldPerHectare ? parseFloat(formData.yieldPerHectare) : 0,
      remarks: formData.remarks,
    };

    try {
      const response = await apiService.put(`/crop-cutting/${selectedCropCuttingId}`, updatedPayload);
      if (response.status === 200) {
        alert('Crop-cutting details updated successfully.');
        setOpen(false);
        fetchData();
      }
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred while saving the changes. Please try again.');
    }
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const renderPaginationItems = () => {
    const paginationItems = [];
    const maxPagesToShow = 7;
    const startPages = 3;
    const endPages = 2;

    if (totalpage <= maxPagesToShow) {
      for (let pages = 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    } else {
      for (let pages = 1; pages <= startPages; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      if (page > startPages + 1) {
        paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }

      const middlePages = [];
      const startMiddlePage = Math.max(page - 1, startPages + 1);
      const endMiddlePage = Math.min(page + 1, totalpage - endPages);

      for (let pages = startMiddlePage; pages <= endMiddlePage; pages++) {
        middlePages.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      paginationItems.push(...middlePages);

      if (page < totalpage - endPages - 1) {
        paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }

      for (let pages = totalpage - endPages + 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    }

    return paginationItems;
  };

  const exportToExcel = async () => {
    try {
      const payload = {
        seedVarietyId: 0,
        cropTypeId: 0,
        farmerName: farName || "",
        seasonName: season || "",
        seedName: seedName || "",
        cropType: cropType || "",
        remarks: remarks || "",
        varietyName: seedVariety || "",
        pgName: pgName || "",
        pgCode: "",
        villageName: village || "",
        gpName: gramPanchayat || "",
        blockName: block || "",
        districtName: district || "",
        yield5x5: yield5x5 || "",
        yieldPerHectare: yieldPerHectare || "",
        year: year,
        dateOfCropCutting: dateOfCropCutting || "",
        mip: "",
        pageNumber: 1,
        pageSize: rowCount,
      };

      const response = await apiService.post("/crop-cutting/get-crop-cutting-index", payload);

      if (response.data.status) {
        const data = response.data.body.data;
        const headers = [
          ['Farmer Name', 'Season', 'District', 'Block', 'Gram Panchayat', 'Village', 'Producer Group', 'Date of Crop Cutting', 'Crop', 'Variety', 'Type', 'Yield (Kg)', 'Yield per Hectare (Qtl)', 'Remarks'],
        ];

        const dataRows = data.map((item) => [
          item.farmerName || "N/A",
          item.seasonName || "N/A",
          item.districtName || "N/A",
          item.blockName || "N/A",
          item.gpName || "N/A",
          item.villageName || "N/A",
          item.pgName || "N/A",
          item.cropCuttingDate ? format(parseISO(item.cropCuttingDate), "dd-MM-yyyy") : "N/A",
          item.seedName || "N/A",
          item.seedVarietyName || "N/A",
          item.cropType || "N/A",
          item.yield5x5 || "N/A",
          item.yieldPerHectare || "N/A",
          item.remarks || "N/A",
        ]);

        const worksheetData = [...headers, ...dataRows];
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Crop Cutting Data');
        XLSX.writeFile(workbook, `CropCutting_Data_${year}.xlsx`);
      }
    } catch (error) {
      console.error("Error exporting data:", error);
    }
  };

  const handleDownloadExcel = () => {
    const headers = ["SlNo", "FarmerName", "PGCode", "Season", "CropCuttingDate", "Crop", "CropVariety", "CropType", "Yield5x5", "YieldPerHectare", "Remarks"];
    const worksheetData = [headers];
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "Crop_Cutting_Upload_Format.xlsx");
  };

  const handleExcelUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const confirmUpload = window.confirm("Are you sure you want to upload this file?");
      if (!confirmUpload) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet);

        const formData = new FormData();
        formData.append("file", file);

        apiService.post("/upload/crop-cutting-upload", formData, {
          headers: {
            accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            alert("File uploaded successfully!");
            fetchData();
          })
          .catch((error) => {
            console.error("Error uploading file:", error);
            alert("Failed to upload file. Please try again.");
            fetchData();
          });
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const startItem = (page - 1) * 10 + 1;
  const endItem = Math.min(page * 10, totalItems);

  return (
    <Box style={{
      backgroundColor: "#f8f9fa",
      overflowY: "auto"
    }}>
      {/* Header - Same design as ffd.jsx */}
      <div style={{
        backgroundColor: "#ffffff",
        borderBottom: "3px solid #007bff",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
      }}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center py-3 px-4">
            <div className="d-flex align-items-center">
              <div>
                <h1 style={{
                  fontSize: "1.8rem",
                  fontWeight: "600",
                  color: "#2c3e50",
                  margin: "0"
                }}>
                  Crop Cutting Management
                </h1>
              </div>
            </div>

            <div className="d-flex align-items-center gap-3">
              <div className="d-flex align-items-center">
                <label style={{
                  fontWeight: "500",
                  color: "#495057",
                  marginRight: "10px",
                  fontSize: "14px"
                }}>
                  Year:
                </label>
                <select
                  className="form-select"
                  value={year || 0}
                  onChange={(e) => setYear(Number(e.target.value))}
                  style={{
                    border: "1px solid #ced4da",
                    borderRadius: "6px",
                    padding: "6px 12px",
                    fontSize: "14px",
                    minWidth: "100px",
                    backgroundColor: "#fff"
                  }}
                >
                  <option value={0} disabled>Select Year</option>
                  {years.map((yr) => (
                    <option key={yr.yearId} value={yr.yearValue}>
                      {yr.yearValue}
                    </option>
                  ))}
                </select>
              </div>

              <Button
                variant="contained"
                onClick={() => navigate('/addcuttingdetails')}
                style={{
                  backgroundColor: "#28a745",
                  border: "none",
                  borderRadius: "6px",
                  padding: "8px 16px",
                  fontSize: "14px",
                  fontWeight: "500",
                  textTransform: "none"
                }}
              >
                + Add Cutting Details
              </Button>

              <Button
                variant="contained"
                component="label"
                startIcon={<UploadIcon />}
                style={{
                  backgroundColor: "#17a2b8",
                  border: "none",
                  borderRadius: "6px",
                  padding: "8px 16px",
                  fontSize: "14px",
                  fontWeight: "500",
                  textTransform: "none"
                }}
              >
                Upload Excel
                <input
                  type="file"
                  accept=".xlsx, .xls"
                  hidden
                  onChange={handleExcelUpload}
                />
              </Button>

              <Button
                variant="contained"
                onClick={handleDownloadExcel}
                style={{
                  backgroundColor: "#6c757d",
                  border: "none",
                  borderRadius: "6px",
                  padding: "8px 16px",
                  fontSize: "14px",
                  fontWeight: "500",
                  textTransform: "none"
                }}
              >
                Download Format
              </Button>

              <Button
                variant="contained"
                startIcon={<Download />}
                onClick={exportToExcel}
                style={{
                  backgroundColor: "#007bff",
                  border: "none",
                  borderRadius: "6px",
                  padding: "8px 16px",
                  fontSize: "14px",
                  fontWeight: "500",
                  textTransform: "none"
                }}
              >
                Export Excel
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content - Same design as ffd.jsx */}
      <div className="container-fluid" style={{ padding: "20px" }}>
        <div style={{
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          display: "flex",
          flexDirection: "column",
          height: "calc(100vh - 160px)"
        }}>
          <div style={{
            flex: "1",
            overflowY: "auto",
            overflowX: "auto"
          }}>
            <div className="table-responsive">
              <table className="table table-hover mb-0" style={{
                minWidth: "2000px",
                backgroundColor: "#fff"
              }}>
                <thead style={{
                  backgroundColor: "#007bff",
                  color: "white",
                  position: "sticky",
                  top: "0",
                  zIndex: "10"
                }}>
                  <tr>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "150px"
                    }}>
                      Farmer Name
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={farName}
                        onChange={(e) => { setFarName(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "120px"
                    }}>
                      Season
                      <br />
                      <select
                        className="form-control form-control-sm mt-2"
                        value={season}
                        onChange={(e) => { setSeason(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      >
                        <option value="">All</option>
                        <option value="Kharif">Kharif</option>
                        <option value="Rabi">Rabi</option>
                      </select>
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "140px"
                    }}>
                      District
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={district}
                        onChange={(e) => {
                          if (dist === 0) {
                            setDistrict(e.target.value);
                            setPage(1);
                          }
                        }}
                        disabled={dist > 0}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "120px"
                    }}>
                      Block
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={block}
                        onChange={(e) => {
                          if (blk === 0) {
                            setBlock(e.target.value);
                            setPage(1);
                          }
                        }}
                        disabled={blk > 0}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "120px"
                    }}>
                      GP
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={gramPanchayat}
                        onChange={(e) => { setGramPanchayat(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "120px"
                    }}>
                      Village
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={village}
                        onChange={(e) => { setVillage(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "150px"
                    }}>
                      Producer Group
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={pgName}
                        onChange={(e) => { setPgName(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "140px"
                    }}>
                      Date of Cutting
                      <br />
                      <input
                        type="date"
                        className="form-control form-control-sm mt-2"
                        value={dateOfCropCutting}
                        onChange={(e) => { setDateOfCropCutting(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "120px"
                    }}>
                      Crop
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={seedName}
                        onChange={(e) => { setSeedName(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "120px"
                    }}>
                      Variety
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={seedVariety}
                        onChange={(e) => { setSeedVariety(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px"
                    }}>
                      Type
                      <br />
                      <select
                        className="form-control form-control-sm mt-2"
                        value={cropType}
                        onChange={(e) => { setCropType(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      >
                        <option value="">All</option>
                        <option value="Production">Production</option>
                        <option value="Demo">Demo</option>
                      </select>
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "120px"
                    }}>
                      5X5 (sq.m)
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={yield5x5}
                        onChange={(e) => { setYield5x5(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "120px"
                    }}>
                      Yield (q/ha)
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={yieldPerHectare}
                        onChange={(e) => { setYieldPerHectare(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "120px"
                    }}>
                      Remarks
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={remarks}
                        onChange={(e) => { setRemarks(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      textAlign: "center",
                      minWidth: "120px"
                    }}>
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: "13px" }}>
                  {rows.map((item, index) => (
                    <tr key={index} style={{
                      backgroundColor: index % 2 === 0 ? "#f8f9fa" : "#ffffff",
                      borderBottom: "1px solid #dee2e6"
                    }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#e3f2fd";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = index % 2 === 0 ? "#f8f9fa" : "#ffffff";
                      }}>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontWeight: "500"
                      }}>
                        {item.farmerName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        <span style={{
                          backgroundColor: item.seasonName === 'Rabi' ? '#d4edda' : '#fff3cd',
                          color: item.seasonName === 'Rabi' ? '#155724' : '#856404',
                          padding: "3px 8px",
                          borderRadius: "4px",
                          fontSize: "11px",
                          fontWeight: "500"
                        }}>
                          {item.seasonName}
                        </span>
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontWeight: "500"
                      }}>
                        {item.districtName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {item.blockName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {item.gpName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {item.villageName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {item.pgName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontSize: "12px"
                      }}>
                        {item.cropCuttingDate ? format(parseISO(item.cropCuttingDate), "dd-MM-yyyy") : "N/A"}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {item.seedName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {item.seedVarietyName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        <span style={{
                          backgroundColor: item.cropType === 'Production' ? '#d1ecf1' : '#f8d7da',
                          color: item.cropType === 'Production' ? '#0c5460' : '#721c24',
                          padding: "3px 8px",
                          borderRadius: "4px",
                          fontSize: "11px",
                          fontWeight: "500"
                        }}>
                          {item.cropType}
                        </span>
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        <span style={{
                          backgroundColor: '#007bff',
                          color: 'white',
                          padding: "3px 8px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          fontWeight: "600"
                        }}>
                          {item.yield5x5}
                        </span>
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        <span style={{
                          backgroundColor: '#28a745',
                          color: 'white',
                          padding: "3px 8px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          fontWeight: "600"
                        }}>
                          {item.yieldPerHectare}
                        </span>
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontSize: "12px"
                      }}>
                        {item.remarks || "N/A"}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center"
                      }}>
                        <div className="d-flex justify-content-center gap-2">
                          <button
                            className="btn btn-sm"
                            onClick={() => handleView(item.id)}
                            style={{
                              backgroundColor: "#007bff",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              padding: "4px 8px",
                              fontSize: "12px"
                            }}
                            title="View"
                          >
                            <FaEye />
                          </button>
                          <button
                            className="btn btn-sm"
                            onClick={() => handleEdit(item.id)}
                            style={{
                              backgroundColor: "#28a745",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              padding: "4px 8px",
                              fontSize: "12px"
                            }}
                            title="Edit"
                          >
                            <FaRegEdit />
                          </button>
                          <button
                            className="btn btn-sm"
                            onClick={() => handleDeleteClick(item.id)}
                            style={{
                              backgroundColor: "#dc3545",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              padding: "4px 8px",
                              fontSize: "12px"
                            }}
                            title="Delete"
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          <div style={{
            borderTop: "1px solid #dee2e6",
            padding: "15px 20px",
            backgroundColor: "#f8f9fa",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}>
            <div style={{
              fontSize: "14px",
              color: "#6c757d"
            }}>
              Showing {startItem} to {endItem} of {totalItems} entries
            </div>
            <Pagination size="sm">
              <Pagination.First onClick={() => handlePageChange(1)} disabled={page === 1} />
              <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1} />
              {renderPaginationItems()}
              <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === totalpage} />
              <Pagination.Last onClick={() => handlePageChange(totalpage)} disabled={page === totalpage} />
            </Pagination>
          </div>
        </div>
      </div>

      {/* Edit Dialog */}
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
        <DialogTitle style={{
          backgroundColor: "#007bff",
          color: "white",
          fontWeight: "600"
        }}>
          Edit Cutting Details
        </DialogTitle>
        <DialogContent style={{ padding: "20px" }}>
          <FormControl fullWidth margin="normal" error={!!errors.SeasonId}>
            <InputLabel id="season-label">Season *</InputLabel>
            <Select
              label="Season"
              labelId="season-label"
              name="SeasonId"
              value={formData.SeasonId}
              onChange={handleChange}
            >
              {seasons.map((season) => (
                <MenuItem key={season.seasonId} value={season.seasonId}>
                  {season.seasonName}
                </MenuItem>
              ))}
            </Select>
            {errors.SeasonId && <FormHelperText>{errors.SeasonId}</FormHelperText>}
          </FormControl>

          <TextField
            fullWidth
            margin="normal"
            label="Crop Cutting Date *"
            name="cropCuttingDate"
            type="date"
            value={formData.cropCuttingDate}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            error={!!errors.cropCuttingDate}
            helperText={errors.cropCuttingDate}
          />

          <FormControl fullWidth margin="normal" error={!!errors.SeedId}>
            <InputLabel id="seed-label">Seed *</InputLabel>
            <Select
              label="Seed"
              labelId="seed-label"
              name="SeedId"
              value={formData.SeedId}
              onChange={handleChange}
            >
              {seeds.map((seed) => (
                <MenuItem key={seed.seedId} value={seed.seedId}>
                  {seed.seedName}
                </MenuItem>
              ))}
            </Select>
            {errors.SeedId && <FormHelperText>{errors.SeedId}</FormHelperText>}
          </FormControl>

          <FormControl fullWidth margin="normal" error={!!errors.SeedVarietyId}>
            <InputLabel id="seed-variety-label">Seed Variety *</InputLabel>
            <Select
              label="Seed Variety"
              labelId="seed-variety-label"
              name="SeedVarietyId"
              value={formData.SeedVarietyId}
              onChange={handleChange}
            >
              {seedVarieties.map((variety) => (
                <MenuItem key={variety.seedVarietyId} value={variety.seedVarietyId}>
                  {variety.varietyName}
                </MenuItem>
              ))}
            </Select>
            {errors.SeedVarietyId && <FormHelperText>{errors.SeedVarietyId}</FormHelperText>}
          </FormControl>

          <FormControl fullWidth margin="normal" error={!!errors.cropTypeId}>
            <InputLabel id="crop-type-label">Crop Type *</InputLabel>
            <Select
              label="Crop Type"
              labelId="crop-type-label"
              name="cropTypeId"
              value={formData.cropTypeId}
              onChange={handleChange}
            >
              {cropTypes.map((crop) => (
                <MenuItem key={crop.cropTypeId} value={crop.cropTypeId}>
                  {crop.cropType}
                </MenuItem>
              ))}
            </Select>
            {errors.cropTypeId && <FormHelperText>{errors.cropTypeId}</FormHelperText>}
          </FormControl>

          <TextField
            fullWidth
            margin="normal"
            label="Yield 5x5 *"
            name="yield5x5"
            value={formData.yield5x5 || ""}
            onChange={(e) => {
              const value = e.target.value;
              setFormData((prevData) => ({
                ...prevData,
                yield5x5: value,
                yieldPerHectare: value ? value * 4 : "",
              }));
            }}
            error={!!errors.yield5x5}
            helperText={errors.yield5x5}
          />

          <TextField
            fullWidth
            margin="normal"
            label="Yield Per Hectare *"
            name="yieldPerHectare"
            value={formData.yieldPerHectare || ""}
            onChange={handleChange}
            disabled
            error={!!errors.yieldPerHectare}
            helperText={errors.yieldPerHectare}
          />

          <TextField
            fullWidth
            margin="normal"
            label="Remarks"
            name="remarks"
            value={formData.remarks || ""}
            onChange={handleChange}
          />
        </DialogContent>
        <DialogActions style={{ padding: "15px 20px" }}>
          <Button
            onClick={() => setOpen(false)}
            style={{
              color: "#6c757d",
              textTransform: "none"
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            style={{
              backgroundColor: "#007bff",
              textTransform: "none"
            }}
          >
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Crop Cutting Details</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
          {selectedData ? (
            <div>
              <p><strong>Farmer Name:</strong> {selectedData.farmerName}</p>
              <p><strong>District:</strong> {selectedData.districtName}</p>
              <p><strong>Block:</strong> {selectedData.blockName}</p>
              <p><strong>GP Name:</strong> {selectedData.gpName}</p>
              <p><strong>Village:</strong> {selectedData.villageName}</p>
              <p><strong>PG Name:</strong> {selectedData.pgName}</p>
              <p><strong>PG Code:</strong> {selectedData.pgCode}</p>
              <p><strong>Season:</strong> {selectedData.seasonName}</p>
              <p><strong>Seed Name:</strong> {selectedData.seedName}</p>
              <p><strong>Seed Variety:</strong> {selectedData.seedVarietyName}</p>
              <p><strong>Crop Type:</strong> {selectedData.cropType}</p>
              <p><strong>Crop Cutting Date:</strong> {selectedData.cropCuttingDate}</p>
              <p><strong>Yield (5x5):</strong> {selectedData.yield5x5}</p>
              <p><strong>Yield per Hectare:</strong> {selectedData.yieldPerHectare}</p>
              <p><strong>Remarks:</strong> {selectedData.remarks || "N/A"}</p>
            </div>
          ) : (
            <p>Loading...</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button color="primary" variant="contained" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Box>
  );
};

export default Cropcosting;